/** @jsxImportSource @emotion/react */
import { Fragment, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import { noop } from "lodash";

import { useTableStoreByRoute } from "@/stores/useTableStore";

import { Column, ROUTES } from "../../../../../shared";
import ListChoice from "../../../../ListChoice/ListChoice";
import useColumnsToShowFunctions from "../../../hooks/useColumnsToShowFunctions";

import { useStyles } from "./styles";

interface ColumnsToShowProps {
  route: ROUTES;
}

const ColumnsToShow = ({ route }: ColumnsToShowProps) => {
  const { t } = useTranslation();

  const { columns, setColumns } = useTableStoreByRoute(route);

  const { columnsToShowOption, columnsToShowTitleCSS } = useStyles();

  const { areDefaultColumns, restoreActiveColumns, toggleActiveColumn } =
    useColumnsToShowFunctions(columns, setColumns);

  const [isResetDisabled, setIsResetDisabled] = useState(areDefaultColumns);

  useEffect(() => {
    setIsResetDisabled(areDefaultColumns);
  }, [columns, areDefaultColumns]);

  return (
    <Fragment>
      <Typography
        variant="body2Medium"
        sx={columnsToShowTitleCSS as any}
        component="div"
      >
        {t("Table##select columns to show")}
      </Typography>

      {columns.map(({ name, isActive, isDisabled }: Column) => {
        return (
          <ListChoice
            key={`${name}-${isActive}`}
            title={t(`Table##${name}`)}
            selected={isActive}
            isCheckbox
            disabled={isDisabled}
            onClick={() => toggleActiveColumn(name)}
          />
        );
      })}

      <ListChoice
        title={t("Button##reset to default")}
        onClick={isResetDisabled ? noop : restoreActiveColumns}
        disabled={isResetDisabled}
        css={css(columnsToShowOption)}
      />
    </Fragment>
  );
};

export default ColumnsToShow;
